import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'
import NameValueTableRow from '../../ui-components/NameValueTableRow'
import { TaxInfo } from '../../../types/rebalance'
import { TaxCategories } from '../../../types/mutual-fund-detail.types'

type LTCGProps = {
  ltcgTaxInfo: TaxInfo
  taxCategory: `${TaxCategories}`
}

export default function LTCG({ ltcgTaxInfo, taxCategory }: LTCGProps) {
  const getLTCGValueText = () => {
    if ([TaxCategories.HYBRID_NON_EQUITY, TaxCategories.NON_EQUITY].includes(taxCategory as TaxCategories)) {
      return `Investment held for 2Y or more`
    }
    if (
      [TaxCategories.EQUITY, TaxCategories.HYBRID_EQUITY, TaxCategories.ELSS].includes(taxCategory as TaxCategories)
    ) {
      return `Investment held for 1Y or more`
    }
    if ([TaxCategories.DEBT, TaxCategories.HYBRID_DEBT].includes(taxCategory as TaxCategories)) {
      return `Investments made before 1 Apr '23`
    }
    return 'Investment held for 1Y or more'
  }

  return (
    <div className='flex flex-col gap-1'>
      <NameValueTableRow
        name={`LTCG Tax @ ${ltcgTaxInfo.taxRate}%`}
        value={roundOffAndFormatNumberWithCurrency(ltcgTaxInfo.taxableAmount).toString()}
        nameClassName='!text-[#095EB2] !font-[500] !text-[13px]'
        valueClassName='!text-[#095EB2] !text-[13px] !font-[500]'
      />
      <NameValueTableRow
        name={`${getLTCGValueText()}`}
        value={roundOffAndFormatNumberWithCurrency(ltcgTaxInfo.investedAmount).toString()}
        nameClassName='!text-[#6A6E6E] !font-[400] !text-[13px]'
        valueClassName='!text-[#6A6E6E] !text-[13px] !font-[400]'
      />
      <NameValueTableRow
        name='Long term capital gains'
        value={
          `${ltcgTaxInfo?.gains < 0 ? '-' : ''}` + roundOffAndFormatNumberWithCurrency(ltcgTaxInfo.gains).toString()
        }
        nameClassName='!text-[#6A6E6E] !font-[400] !text-[13px]'
        valueClassName='!text-[#6A6E6E] !text-[13px] !font-[400]'
      />
    </div>
  )
}
